<template>
    <component class="side-bar" v-if="component" :is="component" :context="context" />
</template>

<script>
import components from './types';

export default {
    name: 'sidebar-type',
    components,
    props: {
        component: {
            type: String,
            required: true
        },
        context: {
            type: Object,
            default: () => {}
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.side-bar {
    position: relative;
    background-color: white;
    border-radius: 5px;
    height: calc(100vh - 235px);
    box-shadow: none;
    border-top: 5px solid map-get($ca-branding, 'primary');
    padding: 1rem;

    &.affix-top {
        position: sticky;
        align-self: flex-start;
        top: 0px;
    }
}
</style>
